import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Text, Toggle } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const Display2ValueToggleItemNonPaneled = ({
  register,
  tc = /** @type {any} */ (undefined),
  icon,
  onChange,
  options,
  inhibitText = false,
  disabled,
}) => {
  const [value, setValue] = useState(register.value);
  const updateValue = (value) => {
    devLog(' Display2ValueToggleItemNonPaneled ', value);

    var ourValue = value === false ? options[0].value : options[1].value;
    setValue(ourValue);
    onChange(register, ourValue);
  };

  const isChecked = () => {
    var result = false;
    if (value == options[1].value) {
      result = true;
    }
    return result;
  };

  useEffect(() => {
    const theValue = register.value;
    setValue(theValue);
    devLog('Display2ValueToggleItemNonPaneled', theValue);
  }, [register.value]);

  return (
    <Flex justifyContent="start" className="space-x-4 ">
      <DisplayIcon icon={icon} />
      {!inhibitText && (
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>{' '}
        </div>
      )}
      <div
        className="truncate w-1/2 space-y-1"
        style={{
          display: 'block',
          width: '50%',
        }}
      >
        <Flex justifyContent="end" className="space-x-4 ">
          <Toggle
            checkedChildren={options[1].label}
            unCheckedChildren={options[0].label}
            size="lg"
            checked={isChecked()}
            disabled={disabled}
            onChange={updateValue}
          />
        </Flex>
      </div>
    </Flex>
  );
};

export const Display2ValueToggleItem = ({
  register,
  tc = /** @type {any} */ (undefined),
  icon,
  onChange,
  options,
  disabled,
  borderOff = false,
}) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Display2ValueToggleItemNonPaneled
        register={register}
        tc={tc}
        icon={icon}
        options={options}
        disabled={disabled}
        onChange={onChange}
      ></Display2ValueToggleItemNonPaneled>
    </Panel>
  );
};
